import script from "./ChoixDiagnosticvsSimulation.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoixDiagnosticvsSimulation.vue?vue&type=script&setup=true&lang=js"

import "./ChoixDiagnosticvsSimulation.vue?vue&type=style&index=0&id=103b0a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103b0a84"]])

export default __exports__